/**
 * Normalize a (masked) email into presence: returns the value only if it looks
 * like an email. A blank/removed contact masks to '***' (no '@'), and null/blank
 * mean no email — all collapse to null so the portal knows to collect one.
 */
export function normalizeMaskedEmail(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed && trimmed.includes('@') ? trimmed : null;
}
